import React, { PureComponent } from 'react';
import { Redirect } from 'react-router-dom';
import '../style/reports.scss';
import Loading from '../components/loading';
import MultiSelect from "@kenshooui/react-multi-select";
import "@kenshooui/react-multi-select/dist/style.css"
import { CSSTransition } from 'react-transition-group';

import { withAlert } from 'react-alert';
import jsPDF from 'jspdf';
import { AppContext } from '../appcontext'
import axios from 'axios';
import { act } from 'react-dom/test-utils';
import moment from 'moment';
import DateRangePicker from '../components/Reports/DateRangePicker';
import SelectCustomer from '../components/Reports/SelectCustomer';
import SelectResource from '../components/Reports/SelectResource';
import SelectService from '../components/Reports/SelectService';
import SelectActivity from '../components/Reports/SelectActivity';
import { arrayforMulti } from "../components/Reports/utils";

class Reports extends PureComponent {
    pdfExportComponent;
    static contextType = AppContext;

    constructor() {
        super();
        let formattedDate = new Date();
        this.state = {
            showChooseLoading: false,
            showprompt: false,
            serviceview: "column",
            activityview: "column",
            resourceview: "column",
            Loading: true,
            numPages: null,
            showResourceReport: false,
            pageNumber: 1,
            customers: [],
            services: [],
            activities: [],
            users: [],
            startdate: formattedDate.getFullYear() + '-' + ((formattedDate.getMonth() + 1) < 10 ? '0' + (formattedDate.getMonth() + 1) : (formattedDate.getMonth() + 1)) + '-' + (formattedDate.getDate() < 10 ? "0" + formattedDate.getDate() : formattedDate.getDate()),
            enddate: formattedDate.getFullYear() + '-' + ((formattedDate.getMonth() + 1) < 10 ? '0' + (formattedDate.getMonth() + 1) : (formattedDate.getMonth() + 1)) + '-' + (formattedDate.getDate() < 10 ? "0" + formattedDate.getDate() : formattedDate.getDate()),
            index: 0,
            showReportPreview: false,
            reportCustomerFullObject: {},
            reportCustomerObject: {},
            reportUserObject: {},
            reportServiceObject: {},
            reportActivityObject: {},
            reportEntriesObject: {},
            usePreviousReport: false,
            selectedCustomers: [],
            selectedServices: [],
            selectedActivities: [],
            selectedUsers: [],
        }
    }
    onShowResourceReport = () => { this.setState({ showResourceReport: !this.state.showResourceReport }) }
    handlePDF = () => {
        var doc = new jsPDF('p', 'pt', 'a4');
        doc.fromHTML(document.getElementById('ServiceReport'), {
            onrendered(canvas) {
                doc.fromHTML(document.getElementById('ActivityeReport'), {
                    onrendered(canvas2) {
                        var img = canvas.toDataURL("image/png");
                        doc.addImage(img, 'JPEG', 0, 0, 210, 230);
                        var img2 = canvas2.toDataURL("image/png");
                        doc.addPage();
                        doc.addImage(img2, 'JPEG', 0, 0, 210, 230);
                        doc.save('test.pdf');
                    }
                });
            }
        });
    }
    handleChange = async (event, value) => {
        this.setState({
            index: value,
        });
    };


    handleChangeIndex = index => {
        this.setState({
            index,
        });
    };
    handleClose = () => {
        this.onShowReportPreview()
    }
    componentWillUnmount() {
        document.removeEventListener("keydown", this.escFunctionForm, false);
    }
    componentDidMount = async () => {
        document.addEventListener("keydown", this.escFunctionForm, false);
        if (this.context.user.usertype > 1)
            await this.context.sendrequest('getcustomers', null, (boolean) => this.setState({ Loading: boolean }), this.props.alert.error)
                .then(async response => {
                    if (response)
                        if (response.data.success) {
                            this.setState({
                                customers: response.data.data,
                            })
                            await this.context.sendrequest('getservices', null, (boolean) => this.setState({ Loading: boolean }), this.props.alert.error)
                                .then(async response => {
                                    if (response)
                                        if (response.data.success) {
                                            this.setState({
                                                services: response.data.data,
                                                activities: [],
                                            })
                                            await this.context.sendrequest('getusers', null, (boolean) => this.setState({ Loading: boolean }), this.props.alert.error)
                                                .then(async response => {
                                                    if (response)
                                                        if (response.data.success) {
                                                            this.setState({
                                                                users: response.data.data,
                                                                allusers: response.data.data,
                                                            })
                                                            await this.context.sendrequest('getactivities', null, (boolean) => this.setState({ Loading: boolean }), this.props.alert.error)
                                                                .then(response => {
                                                                    var LS = localStorage.getItem("report");
                                                                    if (response)
                                                                        if (response.data.success)
                                                                            this.setState({
                                                                                activities: response.data.data,
                                                                                showChooseLoading: false,
                                                                                Loading: false,
                                                                                showprompt: LS ? LS === "[object Object]" ? false : true : false,
                                                                            })
                                                                    window.scrollTo(0, 0);

                                                                })
                                                        }
                                                })
                                        }
                                })

                        }
                })
        else {
            let data = {
                resourceId: this.context.user._id
            }
            await this.context.sendrequest("getcustomer/resourcecustomers", data, (boolean) => this.setState({ Loading: boolean }), this.props.alert.error)
                .then(async response => {
                    if (response)
                        if (response.data.success) {
                            this.setState({
                                customers: response.data.data,
                            })
                            if (response.data.data.length === 1)
                                this.setState({ selectedCustomers: arrayforMulti(response.data.data) })

                            await this.context.sendrequest('getservices', null, (boolean) => this.setState({ Loading: boolean }), this.props.alert.error)
                                .then(async response => {
                                    if (response)
                                        if (response.data.success) {
                                            this.setState({
                                                services: response.data.data,
                                                activities: [],
                                            })
                                            await this.context.sendrequest('getuser', null, (boolean) => this.setState({ Loading: boolean }), this.props.alert.error)
                                                .then(async response => {
                                                    if (response)
                                                        if (response.data.success) {
                                                            this.setState({
                                                                users: [response.data.user],
                                                                allusers: [response.data.user],
                                                            })
                                                            this.setState({ selectedUsers: arrayforMulti([response.data.user]) })
                                                            await this.context.sendrequest('getactivities', null, (boolean) => this.setState({ Loading: boolean }), this.props.alert.error)
                                                                .then(response => {
                                                                    var LS = localStorage.getItem("report");
                                                                    if (response)
                                                                        if (response.data.success)
                                                                            this.setState({
                                                                                activities: response.data.data,
                                                                                showChooseLoading: false,
                                                                                Loading: false,
                                                                                showprompt: LS ? LS === "[object Object]" ? false : true : false,
                                                                            })
                                                                    window.scrollTo(0, 0);

                                                                })
                                                        }
                                                })
                                        }
                                })

                        }
                })
        }
    }
    
    onChangeCustomers = async (selectedCustomers) => {
        this.setState({
            showChooseLoading: true,
            selectedCustomers: selectedCustomers
        })
        if (selectedCustomers.length > 0) {
            var ids = []
            for (let a = 0; a < selectedCustomers.length; a++)
                for (let b = 0; b < selectedCustomers[a].object.resources.length; b++)
                    ids.push(selectedCustomers[a].object.resources[b])
            var data = {
                resources: ids
            }
            await this.context.sendrequest('getcustomer/resources', data, (boolean) => this.setState({ Loading: boolean }), this.props.alert.error)
                .then(response => {
                    if (response.data.success)
                        this.setState({
                            users: response.data.data,
                            showChooseLoading: false,
                        })
                })
        }
        else {
            this.setState({
                users: this.state.allusers,
                showChooseLoading: false,
                selectedUsers: []
            })
        }

    }
    onChnageServices = async (selectedServices) => {
        if (selectedServices.length > 0) {
            this.setState({
                showChooseLoading: true,
                selectedServices: selectedServices
            })
            let sa = [];
            for (let a = 0; a < selectedServices.length; a++) {
                if (selectedServices[a].object.activities)
                    for (let b = 0; b < selectedServices[a].object.activities.length; b++) {
                        sa.push(selectedServices[a].object.activities[b]);
                    }
            }
            if (sa.length > 0) {
                var data = {
                    serviceActivities: sa
                }
                await this.context.sendrequest('getserviceactivities', data, (boolean) => this.setState({ Loading: boolean }), this.props.alert.error)
                    .then(async response => {
                        if (response.data.success) {
                            this.setState({
                                activities: response.data.data,
                            })
                            let activities = [];
                            var LS = localStorage.getItem("report");
                            LS = JSON.parse(LS)

                            if (this.state.usePreviousReport) {
                                LS.ActivityReport.forEach(activity => {
                                    activities.push({
                                        id: activity.activityId,
                                        label: activity.activityName,
                                        object: {
                                            _id: activity.activityId,
                                            name: activity.activityName,
                                        }
                                    })
                                })
                                this.onChangeActivites(activities)
                            }
                            else {
                                this.setState({
                                    showChooseLoading: false
                                })
                            }
                        }
                    })
            }
            else {
                this.setState({
                    selectedActivities: [],
                    showChooseLoading: false,
                    activities: []
                })
            }
        }
        else {
            this.setState({
                selectedActivities: [],
                showChooseLoading: false,
                activities: []
            })
        }
    }
    onChangeActivites = (selectedActivities) => {
        this.setState({
            showChooseLoading: true,
            selectedActivities: selectedActivities
        })
        this.setState({
            showChooseLoading: false
        })
    }
    onChangeUsers = (selectedUsers) => this.setState({ selectedUsers: selectedUsers });

    onGenerateReport = async () => {
        this.setState({
            showChooseLoading: true
        })
        let customerId = [];
        let userId = [];
        let serviceId = [];
        let activityId = [];
        if (this.state.selectedCustomers.length === 0) {
            const alert = this.props.alert;
            alert.error("Customer required");
            this.setState({
                showChooseLoading: false
            })
        }
        else if (this.state.selectedUsers.length === 0) {
            const alert = this.props.alert;
            alert.error("Resource required");
            this.setState({
                showChooseLoading: false
            })
        }
        else if (this.state.selectedServices.length === 0) {
            const alert = this.props.alert;
            alert.error("Service required");
            this.setState({
                showChooseLoading: false
            })
        }
        else if (this.state.selectedActivities.length === 0) {
            const alert = this.props.alert;
            alert.error("Activity required");
            this.setState({
                showChooseLoading: false
            })
        }
        else {
            for (let a = 0; a < this.state.selectedCustomers.length; a++) {
                customerId.push(this.state.selectedCustomers[a].object._id);
            }
            for (let a = 0; a < this.state.selectedUsers.length; a++) {
                userId.push(this.state.selectedUsers[a].object._id);
            }
            for (let a = 0; a < this.state.selectedServices.length; a++) {
                serviceId.push(this.state.selectedServices[a].object._id);
            }
            for (let a = 0; a < this.state.selectedActivities.length; a++) {
                activityId.push(this.state.selectedActivities[a].object._id);
            }
        }
        var data = {
            dates: JSON.stringify({
                startdate: this.state.startdate,
                enddate: this.state.enddate,
            }),
            customerIds: customerId,
            serviceIds: serviceId,
            activityIds: activityId,
            userIds: userId,
        }

        await this.context.sendrequest('generatereport', data, (boolean) => this.setState({ showChooseLoading: false }), this.props.alert.error)
            .then(async response => {
                if (response)
                    if (response.data.success && response.data.data.customerReport.length > 0) {
                        var data = [];
                        await response.data.data.customerReport.map(async customer => {
                            data.push(await this.getCustomer(customer.customerId))
                        })

                        this.setState({
                            reportCustomerObject: response.data.data.customerReport,
                            reportUserObject: response.data.data.userReport,
                            reportServiceObject: response.data.data.serviceEntries,
                            reportActivityObject: response.data.data.activityEntries,
                            reportEntriesObject: response.data.data.entries,
                            reportCustomerFullObject: data
                        })
                        // this.context.setCustomerReport(this.state.reportCustomerObject);
                        // this.context.setServiceReport(this.state.reportServiceObject);
                        // this.context.setActivityReport(this.state.reportActivityObject);
                        // this.context.setUserReport(this.state.reportUserObject);
                        // this.context.setCustomerObject(this.state.reportCustomerFullObject);
                        this.context.setDates(this.state.startdate, this.state.enddate)

                        this.successfulnotification(response.data.message);
                        this.onShowReportPreview();
                    }
                    else if (!response.data.success) {
                        this.setState({
                            showChooseLoading: false,
                        })
                        this.warningnotification("No data was returned from your query")
                    }
            })
        this.setState({
            showChooseLoading: false,
        })
    }
    getCustomer = (id) => {
        let customer = {};
        for (let a = 0; a < this.state.customers.length; a++) {
            if (this.state.customers[a]._id === id) {
                customer = this.state.customers[a];
            }
        }
        return customer;
    }
    onShowReportPreview = () => {
        this.setState({ showReportPreview: !this.state.showReportPreview })
    }
    successfulnotification = (message) => {
        const alert = this.props.alert;
        alert.success(message);
    }
    errornotification = (message) => {
        const alert = this.props.alert;
        alert.error(message);
    }
    warningnotification = (message) => {
        const alert = this.props.alert;
        alert.show(message);
    }
    onChangeBar = () => {
        let tab = this.state.index;
        if (tab === 0)
            this.setState({
                serviceview: "column",
            })
        else if (tab === 1)
            this.setState({
                activityview: "column",
            })
        else
            this.setState({
                resourceview: "column",
            })
    }

    onChangeTable = () => {
        let tab = this.state.index;
        if (tab === 0)
            this.setState({
                serviceview: "table",
            })
        else if (tab === 1)
            this.setState({
                activityview: "table",
            })
        else
            this.setState({
                resourceview: "table",
            })
    }

    onChangePieChart = () => {
        let tab = this.state.index;
        if (tab === 0)
            this.setState({
                serviceview: "pie",
            })
        else if (tab === 1)
            this.setState({
                activityview: "pie",
            })
        else
            this.setState({
                resourceview: "pie",
            })
    }
    escFunctionForm = (event) => {
        if (event.keyCode === 27) {
            this.setState({
                showReportPreview: false
            })
        }
    }

    usePreviousReport = async () => {
        if (localStorage.getItem("report")) {
            this.setState({
                usePreviousReport: true
            })
            var LS = localStorage.getItem("report")
            LS = JSON.parse(LS)

            var customers = []
            LS.CustomerObject.forEach(customer => {
                customers.push({
                    id: customer._id,
                    label: customer.customername,
                    object: customer
                })
            })
            this.setState({ selectedCustomers: customers });

            var users = [];
            LS.UserReport.forEach(user => {
                users.push({
                    id: user.userId,
                    label: user.userName,
                    object: {
                        _id: user.userId,
                        name: user.userName
                    }
                })
            })
            this.setState({ selectedUsers: users });
            var oldservices = []
            for (let a = 0; a < this.state.services.length; a++)
                for (let b = 0; b < LS.ServiceReport.length; b++)
                    if (LS.ServiceReport[b].serviceId === this.state.services[a]._id)
                        oldservices.push({
                            id: this.state.services[a]._id,
                            label: this.state.services[a].name,
                            object: this.state.services[a]
                        })
            let createdDate = new Date();
            let startdate = createdDate.getFullYear() + "-" + (createdDate.getMonth() + 1 < 10 ? "0" + (createdDate.getMonth() + 1) : createdDate.getMonth() + 1) + "-" + createdDate.getDate();
            await this.onChnageServices(oldservices)
                .then(
                    this.setState({
                        startdate: LS.startdate > "" ? LS.startdate : startdate,
                        enddate: LS.enddate > "" ? LS.enddate : startdate,
                        showChooseLoading: false,
                        Loading: false,
                        showprompt: false,
                    })
                )

        }
        else {
            this.error("Something went wrong with the request")
            this.setState({
                showprompt: false,
            })
            this.setState({ selectedUsers: [] });
        }
    }
    render() {
        document.body.style.overflow = this.state.Loading ? "hidden" : "visible"
        if (this.state.showReportPreview) {
            return <Redirect to={{
                pathname: `/${this.context.user.firstname}/reports/preview`,
                reportCustomerFullObject: this.state.reportCustomerFullObject,
                reportCustomerObject: this.state.reportCustomerObject,
                reportUserObject: this.state.reportUserObject,
                reportServiceObject: this.state.reportServiceObject,
                reportActivityObject: this.state.reportActivityObject,
                reportEntriesObject: this.state.reportEntriesObject,
            }} />
        }
        else
            return (
                <div className="pageContainer">
                    <h1 id="heading">Reports</h1>
                    <hr id="line" />
                    {/* <CSSTransition
 in={localStorage.getItem("report") && this.state.showprompt ? true : false}
 // in={true}
 appear={true}
 timeout={300}
 classNames="fade"
 unmountOnExit
 >
 <Loading />
 </CSSTransition> */}
                    <CSSTransition
                        // in={this.state.showprompt}
                        in={false}
                        appear={true}
                        timeout={300}
                        classNames="fade"
                        unmountOnExit
                    >
                        <div className="mother">
                            <div className="comfirmDialog">
                                <h4>Would you like to use the previous report ?</h4>
                                <div className="comfirmDialogButtons">
                                    <button className="comfirmDialogCancel" type="button" onClick={this.usePreviousReport}>Yes</button>
                                    <button className="comfirmDialogCancel" type="button" onClick={() => this.setState({ showprompt: false })}>No</button>
                                </div>
                            </div>
                        </div>
                    </CSSTransition>
                    
                    {
                        this.state.Loading ? <Loading /> :
                            <div className="ReportsContainer">
                                <h4 className="reports-sub-heading">Dates</h4>
                                <DateRangePicker
                                    startdate={this.state.startdate}
                                    enddate={this.state.enddate}
                                    onStartDateChange={(startdate) => this.setState({ startdate })}
                                    onEndDateChange={(enddate) => this.setState({ enddate })}
                                />
                                
                                <h4 className="reports-sub-heading">Customers & Resources</h4>
                                <div className="ReportOptions">
                                    <CSSTransition
                                        in={this.state.showChooseLoading}
                                        appear={true}
                                        timeout={300}
                                        classNames="fade"
                                        unmountOnExit
                                    >
                                        <Loading />
                                    </CSSTransition>
                                    <SelectCustomer
                                        customers={this.state.customers}
                                        onChange={this.onChangeCustomers}
                                        selectedItems={this.state.selectedCustomers}
                                    />
                                    <SelectResource
                                        users={this.state.users}
                                        onChange={this.onChangeUsers}
                                        selectedItems={this.state.selectedUsers}
                                    />
                                </div>
                                <h4 className="reports-sub-heading">Services & Activities</h4>
                                <div className="ReportOptions">
                                    <SelectService
                                        services={this.state.services}
                                        onChange={this.onChnageServices}
                                        selectedItems={this.state.selectedServices}
                                    />
                                    <SelectActivity
                                        activities={this.state.activities}
                                        onChange={this.onChangeActivites}
                                        selectedItems={this.state.selectedActivities}
                                    />
                                </div>
                                <div className="ReportSubmitOptions">
                                    <button className="Submit" type="button" onClick={() => this.onGenerateReport()}>Generate Report</button>
                                </div>
                            </div>
                    }
                </div >
            )
    }
}
export default withAlert()(Reports)